/* ⚛ REACT */
import { useEffect, useState } from "react";

/* 🎨 STYLES */
import { Container, ContainerInput, CheckboxInput, CheckboxMark, Text, Spinner } from "./styles";

const InputCheckbox = (props) => {

    const [checked, setChecked] = useState(props.checked === true)
    const [isLoading, setIsLoading] = useState(false)

    const change = async() => {
        setIsLoading(true);
        let success = await props.onChange(!checked);
        setIsLoading(false);
        if(success){
            setChecked(!checked);
        }
    }

    useEffect(() => {
        setChecked(props.checked === true);
    }, [props.checked])

    return(
        <Container $aling={props.aling} id={props.id}>
            <ContainerInput>
                {isLoading ?
                    <Spinner/>
                : 
                    <>
                        <CheckboxInput checked={checked} onChange={() => {
                            !props.disabled && change()
                        }} />
                        <CheckboxMark $disabled={props.disabled} checked={checked} onClick={() => {
                            !props.disabled && change()
                        }}/>
                    </>
                }
                <Text $disabled={props.disabled}>{props.text}</Text>
            </ContainerInput>
        </Container>
    )
}

export default InputCheckbox;